const pixel = (value) => `${value}px`;
const half = (value) => value / 2;
const viewBox = (value) => `0 0 ${value} ${value}`;
const radius = (size, stroke) => half(size) - half(stroke);
const dashArray = (size, stroke) => (2 * Math.PI * (radius(size, stroke)));
const dashoffset = (size, stroke, value) => ((100 - value) / 100) * (2 * Math.PI * (radius(size, stroke)));
export { pixel, half, viewBox, radius, dashArray, dashoffset };
